<h2 mat-dialog-title>Add Link</h2>

<mat-dialog-content>
  <div *ngIf="dialogError" class="api-error-banner" style="margin-bottom: 15px;">{{ dialogError }}</div>
  <div class="api-error-banner" *ngIf="validationErrors.length > 0">
    <div>Please fix following errors:</div>
    <ul>
      <li *ngFor="let error of validationErrors">{{ error }}</li>
    </ul>
  </div>

  <div class="add-form-grid">
    <!-- Office -->
    <mat-form-field appearance="outline" class="link-field">
      <mat-label>Office</mat-label>
      <input
        matInput
        [formControl]="officeControl"
        [matAutocomplete]="officeAuto"
        #officeTrigger="matAutocompleteTrigger"
        placeholder="Search offices..."
      />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="!!officeControl.value"
        [panelOpen]="officeTrigger.panelOpen"
        (clearClicked)="clearOffice($event)"
        (toggleClicked)="openOrClosePanel($event, officeTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete
        #officeAuto="matAutocomplete"
        [clearStaleSelectionOnOpen]="officeControl.value"
        [displayWith]="displayOfficeFn"
        (optionSelected)="onOfficeSelected($event.option.value)"
      >
        <mat-option *ngFor="let option of filteredOfficeOptions$ | async" [value]="option">
          {{ option.mailingName }} - {{ option.officeKey }}
        </mat-option>
      </mat-autocomplete>
      <mat-hint *ngIf="officesErrorMessage" class="field-error">{{ officesErrorMessage }}</mat-hint>
    </mat-form-field>

    <!-- RRE -->
    <mat-form-field appearance="outline" class="link-field">
      <mat-label>RRE</mat-label>
      <input
        matInput
        [formControl]="rreControl"
        [matAutocomplete]="rreAuto"
        #rreTrigger="matAutocompleteTrigger"
        [placeholder]="loadingRres ? 'Loading RREs...' : 'Search RREs...'"
        (focus)="openPanel(rreTrigger)"
        (click)="openPanel(rreTrigger)"
      />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="!!rreControl.value"
        [toggleDisabled]="rreControl.disabled"
        [panelOpen]="rreTrigger.panelOpen"
        (clearClicked)="clearRre($event)"
        (toggleClicked)="openOrClosePanel($event, rreTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete
        #rreAuto="matAutocomplete"
        [clearStaleSelectionOnOpen]="rreControl.value"
        [displayWith]="displayRreFn"
        (optionSelected)="onRreSelected($event.option.value)"
      >
        <mat-option *ngFor="let option of filteredRreOptions$ | async" [value]="option">
          {{ option.rre }}{{ option.rreName ? ' - ' + option.rreName : '' }}
        </mat-option>
      </mat-autocomplete>
      <mat-hint *ngIf="rresErrorMessage" class="field-error">{{ rresErrorMessage }}</mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" type="button" (click)="onSubmit()">
    Submit
  </button>
  <button mat-stroked-button type="button" (click)="onCancel()">
    Cancel
  </button>
</mat-dialog-actions>
